<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.one_time_depositor") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-12.col-lg-3.col-xl-3.col-12.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getListing()" size="sm")
              .form-group.col-md-12.col-lg-3.col-xl-3.col-12.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.month") }}
                  b-form-select(size="sm" :options="monthOpt" v-model="selectedMonth" @change="getListing()" :disabled="loading")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getListing()"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcelFull(v-if="reportList.length > 0" mode="OneTimeDepositor" :dttbl="reportList" :date="dateRange" type="1" :loading2="loading2" btnTxt="export_one").mr-2
                jsonToExcelFull(v-if="reportListFull.length > 0" mode="OneTimeDepositor" :dttbl="reportListFull" :date="dateRange" type="1" :loading2="loading2" btnTxt="export_all")
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12(style="max-height: 70vh; overflow: hidden;")
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover#tblList
                    thead.thead-light
                      tr
                        th.text-center(width="5%")
                          span #
                        th(width="15%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th(width="15%")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                        th(width="30%")
                          span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
                        th.text-right(width="30%" @click="sortOrder('ticket_date')")
                          span(:title="$t('ui.ticket_date')") {{ $t('ui.ticket_date') }}
                          .float-right
                            i(:class="changeSortKey('ticket_date')")
                    tbody.clusterize-content
                      tr(v-if="reportList.length == 0")
                        td(:colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in reportList")
                        td.text-center
                          span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.parent_id") {{ item.parent_id }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}
                        td.text-right
                          span(v-if="item.ticket_date" :title="$moment(item.ticket_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.ticket_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    jsonToExcelFull
  },
  data: () => ({
    loading: false,
    loading2: false,
    reportList: [],
    reportListFull: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    monthOpt: [],
    selectedMonth: null,
    sortKey: "account_id",
    sortType: "asc",
    dateRange: {
      startDate: null,
      endDate: null
    },
    searchID: '',
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.getDateOpt();
      if(this.isOperator) {
        this.searchID = this.accountID
        this.getListing();
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        // if(this.searchID.trim() != null && this.searchID.trim() != '') {
        //   this.getReport(true);
        //   this.getReportFull();
        // }
        this.getListing();
      }
    }
  },
  methods: {
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD"),
        end_date: this.$moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD")
      };

      this.$store.dispatch("user/setReportStatementParam", json);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getReport(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getListing() {
      this.dateRange.startDate = this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD");
      this.dateRange.endDate = this.$moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD");
      this.getReport(true);
      this.getReportFull();
    },
    getDateOpt() {
      for(var i = 0; i > -12; i--) {
        this.monthOpt.push(this.$moment(new Date).add(i, 'month').format('YYYY-MM'));
      }

      var hasMonth = false

      if (this.$store.getters.reportStatement.start_date != null && this.$store.getters.reportStatement.start_date != '') {
        var sMonth = this.$moment(this.$store.getters.reportStatement.start_date).startOf("month").format("YYYY-MM");
        if(this.monthOpt.includes(sMonth)) {
          hasMonth = true
          this.selectedMonth = sMonth
        }
      }
      if(!hasMonth)
        this.selectedMonth = this.$moment(new Date).format('YYYY-MM');
    },
    getReportFull: function(isSearch) {
      // if (this.searchID.trim() == '') {
      //   this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
      //   return;
      // }
      this.setReportStatementParam();
      let url = config.oneTimeDepositorUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.searchID.trim(),
        working_month: this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: -1
      };

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reportListFull = response.data.dt;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getReport: function(isSearch) {
      // if (this.searchID.trim() == '') {
      //   this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
      //   return;
      // }
      let url = config.oneTimeDepositorUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.searchID.trim(),
        working_month: this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reportList = response.data.dt;
                this.totalRow = this.reportList.length > 0 ? this.reportList[0].totalrows : 0;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getReport(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getReport();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>